import React, { useState, useEffect, useContext } from "react";
import { Button } from "react-bootstrap";
import { DropdownSelect } from "../../Components";
import { DataContext } from "../../js/App";
import { getUUID, GET_CLAIMANTS as getClaimants, GET_EXTRA_FIELD } from "../../utils/helpers";
import Standard from "../FormTypes/Standard";
import "./claimantSelect.scss";

const ClaimantSelect = () => {
  const context = useContext(DataContext);
  const [claimants, setClaimants] = useState([]);
  const [extraInputField, setExtraInputField] = useState([]);
  const [selectedPolicyField, setSelectedPolicyField] = useState(null);
  const { providerData, policyForm, setActiveTab, claimantDescription, appUserPolicyData, webFormData } = context;
  const policies = providerData.data.provider.policies;

  useEffect(() => {
    setClaimants(getClaimants(policies, webFormData));
    setExtraInputField(GET_EXTRA_FIELD(policies));
  }, []);

  useEffect(() => {
    if(appUserPolicyData !== null && typeof appUserPolicyData !== 'undefined'){
      const extraField = extraInputField.find(x => x.id == appUserPolicyData.policyId);
      if(extraField !== null && typeof extraField !== undefined && typeof extraField.fieldObj !== 'undefined'){
        setSelectedPolicyField(extraField.fieldObj);
      }
    }
  }, [appUserPolicyData]);

  const handleAcceptClaimant = () => {
    if (typeof policyForm !== 'undefined') {
      setActiveTab(policyForm[0].title);
    }
  };

  return (
    <>
      <h2>Claimant</h2>
      <div className="claimantDescription" dangerouslySetInnerHTML={{ __html: claimantDescription }}>
      </div>
      <hr />
      <DropdownSelect
        name={"Claimant Select"}
        fieldLabel={"Who are you?"}
        claimantSelect={true}
        options={claimants}
      />
      {selectedPolicyField && (
        <Standard
        name={"claimant_"+selectedPolicyField.name}
        key={"claimant_"+selectedPolicyField.name}
        fieldLabel={selectedPolicyField.label}
        type={"text"}
        placeholder={selectedPolicyField.placeholder}
        defaultValue={selectedPolicyField.defaultValue}
        labelPlaceholder={selectedPolicyField.labelPlaceholder}
      />
      )}
      <hr />
      <div className="agreeButtonContainer">
        <Button disabled={policyForm !== null ? false : true} onClick={() => handleAcceptClaimant()} variant="primary">
          Continue
        </Button>
      </div>
    </>
  );
};

export default ClaimantSelect;
